var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('section',{attrs:{"id":"instagram_area_one"}},[_c('div',{staticClass:"container"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-lg-12"},[_c('div',{staticClass:"left_heading_three insta_heading_elce"},[_c('h2',{staticClass:"text-uppercase"},[_vm._v("Follow Us Instagram")])])])])])])
}]

export { render, staticRenderFns }